<template>
    <div class="chat-content">
        <div
            :class="groupDirection === 'out' ? `bg-primary text-white` : 'bg-white'"
            class="chat-entry chat-entry-text"
        >
            <p v-linkified class="chat-entry-content" v-html="parseMessageAndEnlargeEmoji(entry)"></p>

            <small :class="groupDirection === 'out' ? `text-white` : ''" class="chat-time text-right w-100 d-block">
                {{
                    formatDate(entry.createdAt, {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
                <template v-if="groupDirection === 'out' && ['delivered', 'read'].includes(status)">
                    <span
                        v-b-tooltip.hover.right="status"
                        :class="entry.status === 'read' ? 'read' : ''"
                        class="saysimple-icon check-double ml-50 mr-50"
                    />
                </template>
                <template v-else-if="status && groupDirection === 'out' && resolveMessageStatusIcon(status)">
                    <font-awesome-icon
                        v-b-tooltip.hover.right="status"
                        :class="resolveMessageStatusClass(status)"
                        :icon="resolveMessageStatusIcon(status)"
                        class="ml-50"
                    />
                </template>
            </small>
        </div>
    </div>
</template>

<script>
import { BButton, VBTooltip } from "bootstrap-vue";
import { resolveMessageStatusIcon, resolveMessageStatusClass } from "@/utils/chats";
import { resolveTemplateButtonIcon } from "@/utils/templates";
import { formatDate } from "@/utils/luxon";
import { resolvePlatformColor, supportsMessageStatusUpdates } from "@/utils/channels";
import messageParser from "@/utils/messageParser";
import linkify from "vue-linkify";

export default {
    directives: {
        linkified: linkify,
        "b-tooltip": VBTooltip,
    },
    components: {
        BButton,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
        entry: {
            type: Object,
            required: true,
        },
        groupDirection: {
            type: String,
            required: true,
        },
        formattedActiveChatData: {
            type: Array,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
    },
    methods: {
        parseMessageAndEnlargeEmoji: (entry) => {
            const message = messageParser(entry.message, {
                platform: "WEB",
            });
            const singleEmojiRegex = /^<span class="emoji">\S+<\/span>$/;
            const isSinlge = singleEmojiRegex.test(message);
            const emoji = isSinlge
                ? message.replace(`class="emoji"`, `class="emoji chat-entry-single-emoji"`)
                : message;

            return emoji;
        },
    },
    setup() {
        return {
            formatDate,
            messageParser,
            resolveMessageStatusClass,
            resolveMessageStatusIcon,
            resolvePlatformColor,
            resolveTemplateButtonIcon,
            supportsMessageStatusUpdates,
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/components/inbox/smoochShorthand.scss";
</style>
